import { PromoSource, Routes } from '@/app/enums';
import { FooterNavigationSection } from '@/app/utils/countryConfig';

// Slovak footer navigation sections
export const footerNavigationSectionsForSK: FooterNavigationSection[] = [
  {
    titleTranslationKey: 'components.FooterNavigation.whatDonioIs',
    items: [
      {
        titleTranslationKey: 'components.FooterNavigation.teamAndValues',
        path: Routes.ABOUT_US,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.published',
        path: Routes.WROTE_ABOUT_US,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.donioInNumbers',
        path: Routes.YEAR_BOOK_2024,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.yearBooks',
        path: Routes.YEAR_BOOKS,
      },
    ],
  },
  {
    titleTranslationKey: 'components.FooterNavigation.howItWorks',
    items: [
      {
        titleTranslationKey: 'components.FooterNavigation.howDonioWorks',
        path: Routes.HOW_IT_WORKS,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.onlineFundraising',
        path: Routes.FUNDRAISING,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.rewardCrowdfunding',
        path: Routes.CROWDFUNDING,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.goodHabit',
        path: Routes.MOJADOBROKARTA,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.donioTransparentAcount',
        path: Routes.TRANSPARENT_ACCOUNT,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.cerctificateOfGoodness',
        path: Routes.XMAS,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.twoPercents',
        path: Routes.PAGE_TWO_PERCENT,
      },
    ],
  },
  {
    titleTranslationKey: 'components.FooterNavigation.forWhoWeAreHereFor',
    items: [
      {
        titleTranslationKey: 'components.FooterNavigation.individuals',
        path: Routes.INDIVIDUALS,
      },
      {
        path: Routes.NON_PROFIT,
        titleTranslationKey: 'components.FooterNavigation.ngos',
      },
      {
        path: Routes.FOR_COMPANIES,
        titleTranslationKey: 'components.FooterNavigation.companies',
      },
      {
        path: Routes.PARTNERS,
        titleTranslationKey: 'components.FooterNavigation.partners',
      },
      {
        path: Routes.AMBASSADOR,
        titleTranslationKey: 'components.FooterNavigation.ambassadors',
      },
      {
        path: Routes.PRESS,
        titleTranslationKey: 'components.FooterNavigation.media',
      },
    ],
  },
  {
    titleTranslationKey: 'components.FooterNavigation.links',
    items: [
      {
        path: Routes.CONTACT,
        titleTranslationKey: 'components.FooterNavigation.contact',
      },
      {
        path: Routes.BLOG_HOMEPAGE,
        titleTranslationKey: 'components.FooterNavigation.news',
      },
      {
        path: Routes.FAQ,
        titleTranslationKey: 'components.FooterNavigation.faq',
      },
      {
        path: Routes.CODE_OF_ETHICS,
        titleTranslationKey: 'components.FooterNavigation.donioCode',
      },
      {
        path: Routes.TERMS_AND_CONDITIONS,
        titleTranslationKey: 'components.FooterNavigation.termsAndConditions',
      },
      {
        path: Routes.PRIVACY_POLICY,
        titleTranslationKey: 'components.FooterNavigation.privacyPolicy',
      },
    ],
  },
];

export const footerNavigationSectionsForCZ = [
  {
    titleTranslationKey: 'components.FooterNavigation.collections',
    items: [
      {
        titleTranslationKey: 'components.FooterNavigation.howToCreateCollection',
        path: Routes.HOW_TO_CREATE_CHARITY_COLLECTION,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.activeCollections',
        path: Routes.ACTIVE_COLLECTIONS,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.finishedCollections',
        path: Routes.FINISHED_COLLECTIONS,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.regularDonor',
        path: `${Routes.REGULAR_DONOR}?promo-source=${PromoSource.FOOTER}`,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.floodings2024',
        path: Routes.FLOODINGS_2024,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.ukraine',
        path: Routes.HELP_UKRAINE,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.aboutCharityCrowdfunding',
        path: Routes.ABOUT_CHARITY_CROWDFUNDING,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.goodHabit',
        path: Routes.GOOD_HABIT,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.longTermProjects',
        path: Routes.LONG_TERM_COLLECTIONS,
      },
    ],
  },
  {
    titleTranslationKey: 'components.FooterNavigation.commercialProjects',
    items: [
      {
        titleTranslationKey: 'components.FooterNavigation.howToCreateProject',
        path: Routes.HOW_TO_CREATE_COMMERCIAL_PROJECT,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.activeProjects',
        path: Routes.ACTIVE_PROJECTS,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.finishedProjects',
        path: Routes.FINISHED_PROJECTS,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.aboutRewardCrowdfunding',
        path: Routes.ABOUT_REWARD_CROWDFUNDING,
      },
    ],
  },
  {
    titleTranslationKey: 'components.FooterNavigation.forWhoWeAreHereFor',
    items: [
      {
        titleTranslationKey: 'components.FooterNavigation.ngos',
        path: Routes.NGOS,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.companies',
        path: Routes.COMPANIES,
      },
    ],
  },
  {
    titleTranslationKey: 'components.FooterNavigation.whatDonioIs',
    items: [
      {
        titleTranslationKey: 'components.FooterNavigation.howDoesItWork',
        path: Routes.HOW_DOES_IT_WORK,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.aboutUs',
        path: Routes.ABOUT_US,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.career',
        path: Routes.CAREER,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.published',
        path: Routes.IN_MEDIA,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.annualReport',
        path: Routes.ANNUAL_REPORT_2023,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.media',
        path: Routes.FOR_MEDIA,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.contact',
        path: Routes.CONTACT,
      },
    ],
  },
  {
    titleTranslationKey: 'components.FooterNavigation.links',
    items: [
      {
        titleTranslationKey: 'components.FooterNavigation.faqs',
        path: Routes.FAQS,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.blog',
        path: Routes.BLOG,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.competitionBenchmark',
        path: Routes.PLATFORM_BENCHMARK,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.aboutPublicCollection',
        path: Routes.OPEN_ACCOUNT,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.privacyPolicy',
        path: Routes.PRIVACY_POLICY,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.termsAndConditions',
        path: Routes.TERMS_AND_CONDITIONS,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.termsAndConditions_2025_04_15',
        path: Routes.TERMS_AND_CONDITIONS_2025_04_15,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.donioCode',
        path: Routes.DONIO_CODE,
      },
      {
        titleTranslationKey: 'components.FooterNavigation.cookies',
        path: Routes.COOKIES,
      },
    ],
  },
];
